module.exports = __webpack_public_path__ + "static/water_glacier11-394237a0746287364e636869a847f855.jpg";